import Vue from 'vue';
import Vuex from 'vuex';
import VueAsyncData from 'vue-async-data';
import middlewares from './middlewares';

Vue.use(Vuex);
Vue.use(VueAsyncData);

const state = {

};

const mutations = {

};

export default new Vuex.Store({
	state,
	mutations,
	middlewares
});



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/race-schedule/vuex/store.js
 **/